// 导入路由
import Vue from 'vue'
import VueRouter from 'vue-router'
// 引入组件
import home from '../view/home.vue'
import policy from '../view/policy.vue'
import policyDetail from '../view/policyDetail.vue'
import login from '../view/login/login.vue'
// import loginBox from '../view/login/loginBox.vue'
import detail from '../view/detail.vue'
import accuratePage from "../view/accuratePage/accuratePage.vue"
import userCenter from '../view/userCenter/userCenter.vue'
import setPage from '../view/setPage/setPage.vue'
import matchPage from '../view/matchPage/matchPage.vue'
import forgetPassword from '../view/forgetPassword/forgetPassword'
import getPassword from '../view/getPassword/getPassword'
// 解决编程式路由往同一地址跳转时会报错的情况
const originalPush = VueRouter.prototype.push;
const originalReplace = VueRouter.prototype.replace;

// push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch(err => err);
};

//replace
VueRouter.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalReplace.call(this, location, onResolve, onReject);
  return originalReplace.call(this, location).catch(err => err);
};

Vue.use(VueRouter)


// 创建路由对象
const routes = [
  {
    path: '/',
    name: '首页',
    components: {
      default: home
    }
  },
  {
    path: '/policy',
    name: '政策',
    redirect: "/policy/policyDetail",
    components: {
      default: policy
    },
    children: [
      {
        path: '/policy/policyDetail',
        component: policyDetail
      }
    ]
  },
  {
    path: '/login',
    name: '登录',
    components: {
      default: login
    },
    meta: {
      notShowFooter: true
    }
  },
  {
    path: '/detail',
    name: '申报项目',
    components: {
      default: detail
    }
  },
  {
    path: '/accuratePage',
    name: '精准匹配',
    redirect: "/accuratePage/userCenter",
    components: {
      default: accuratePage
    },
    meta: {
      notShowFooter: true
    },
    children: [
      {
        path: '/accuratePage/userCenter',
        component: userCenter,
        meta: {
          notShowFooter: true
        }
      },
      {
        path: '/accuratePage/matchPage',
        component: matchPage,
        meta: {
          notShowFooter: true
        }
      },
      {
        path: '/accuratePage/setPage',
        component: setPage,
        meta: {
          notShowFooter: true
        }
      }
    ]
  },
  {
    path: '/forgetPassword',
    name: '忘记密码',
    components: {
      default: forgetPassword
    },
    meta: {
      notShowFooter: true
    }
  },
  {
    path: '/getPassword',
    name: '取回密码',
    components: {
      default: getPassword
    },
    meta: {
      notShowFooter: true
    }
  }
]

const router = new VueRouter({
  // mode: 'history',
  mode: 'hash',
  routes
})

export default router